import { PAYMENT_ICON_FILES, type PaymentIconName } from './paymentIcons';

interface PaymentIconProps {
  icon: PaymentIconName;
}

// 图卡底色铺满、字标等比居中的规则由 SVG 两层画布负责，不能再使用 cover。
export function PaymentIcon({ icon }: PaymentIconProps) {
  return (
    <span
      aria-hidden="true"
      data-payment-icon={icon}
      className="block shrink-0 overflow-hidden rounded-[2px] bg-transparent bg-center bg-no-repeat"
      style={{
        width: 'var(--payment-icon-width, 36px)',
        aspectRatio: 'var(--payment-icon-ratio, 3 / 2)',
        backgroundSize: '100% 100%',
        backgroundImage: `url(/zeelool-next/home-page/${PAYMENT_ICON_FILES[icon]})`,
      }}
    />
  );
}
